<template>
    <div class="main-cn">
        <div class="main-bd  pro-visible"  v-bind:class="{mg20:!isDialog}">
            <el-tabs v-model="activeTab" v-if="!isDialog">
                <el-tab-pane label="下载日志" name="downLog"></el-tab-pane>
            </el-tabs>
            <el-form  ref="form" :inline="true" :model="searcherModel" class="demo-form-inline">
                <el-form-item label="客户名称(不支持模糊搜索)" v-if="!isDialog">
                    <CustomerSelect ref="customer" placeholder="请输入客户名称" width="800px"  v-model="searcherModel.customer_id"
                                    @change="CustomerHandleChange"></CustomerSelect>
                </el-form-item>
                <el-form-item label="客户ID" v-if="!isDialog">
                    <el-input size="small" type="number" v-model="searcherModel.customer_id" placeholder="请输入客户id"></el-input>
                </el-form-item>
                <el-form-item label="车厢ID" v-if="!isDialog">
                    <el-input size="small" type="number" v-model="searcherModel.group_id" placeholder="请输入车厢ID"></el-input>
                </el-form-item>
                <el-form-item label="用户名(不支持模糊搜索)">
                    <el-input  size="small" v-model="searcherModel.user_name" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名">
                    <el-input  size="small" v-model="searcherModel.real_name" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="用户ID">
                    <el-input  size="small" v-model="searcherModel.uid" placeholder="请输入用户ID"></el-input>
                </el-form-item>
                <el-form-item label="学段筛选">
                    <el-select size="small" v-model="searcherModel.stage" placeholder="请选择">
                        <el-option v-for="(item, key) in xd" :key="key" :label="item" :value="key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="科目筛选">
                    <el-select size="small" v-model="searcherModel.subject_id" placeholder="请选择">
                        <el-option v-for="(item, key) in subjects" :key="item.subject_id" :label="item.subject_name"
                                   :value="item.subject_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型筛选">
                    <el-select size="small" v-model="searcherModel.asset_type" placeholder="请选择">
                        <el-option v-for="(item, key) in types" :key="key" :label="item"
                                   :value="key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间筛选">
                    <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            v-model="searcherModel.time"
                            value-format="timestamp"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="来源" prop="level">
                    <el-select v-model="searcherModel.source" placeholder="请选择" size="small">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="主站" value="0"></el-option>
                        <el-option label="校本3" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" size="small" @click="submitSearch" icon="el-icon-search">搜索
                    </el-button>
                    <el-button size="small" @click="resetForm()">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="success" @click="exportXwt('log')">导出Excel(最多导出10000条)</el-button>
                    <el-button size="small" type="success" @click="exportXwt('doc')">在线生成报表</el-button>
                </el-form-item>
            </el-form>
            <div>学币使用量：<span style="color: red">{{coin_sum}}</span>个学币</div>
            <div><span style="color: red;float: right;">未选择时间，默认只展示今年下载记录</span></div>
            <el-table :data="list" style="width: 100%" v-loading="loading"
                      class="scrollbar tabTopBorder order-tab-list">
                <template slot="empty">
                    <span >请输入查询条件进行查询</span>
                </template>
                <el-table-column label="资料ID" prop="itemid">
                    <template slot-scope="scope">
                        <a href="javascript:void(0)" style="color: #409EFF" @click="showDetail(scope.row)">{{scope.row.subject_id}}-{{scope.row.asset_id}}</a>
                    </template>
                </el-table-column>
                <el-table-column label="资料标题" prop="title" width="300"></el-table-column>
                <el-table-column label="学段/科目">
                    <template slot-scope="scope">
                        {{xd[scope.row.stage]}}/
                        <span v-for="item in subjects">
                            <span v-if="item.subject_id == scope.row.subject_id ">
                                {{item.subject_name}}
                            </span>
                    </span>
                    </template>
                </el-table-column>
                <el-table-column label="车厢ID">
                    <template slot-scope="scope">
                        {{scope.row.group_id}}
                    </template>
                </el-table-column>
                <el-table-column label="学校名称" prop="customer_name">
                    <template slot-scope="scope">
                        <el-button @click="handleView(scope.row)" type="text" size="small">{{scope.row.customer_name}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="用户名" prop="username"></el-table-column>
                <el-table-column label="真实姓名" prop="real_name"></el-table-column>
                <el-table-column prop="asset_type_name" label="类型">
                </el-table-column>
                <el-table-column prop="source_memo" label="来源">
                </el-table-column>
                <el-table-column prop="ip" label="IP地址">
                </el-table-column>
                <el-table-column prop="asset_coin" label="实扣">
                </el-table-column>
                <el-table-column label="下载时间" prop="created_at">
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
    import Pagination from "~/widgets/Pagination.vue";
    import Log from "~/services/log";
    import Params from "~/config/params";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    import Function from "~/common/functions";
    import moment from 'moment'


    export default {
        components: {
            Pagination,
            CustomerSelect
        },
        props:{
          isDialog:{
              required:false,
              type:Boolean
          },
            ztcId:{
              required:false,
          }
        },
        data() {
            let date = new Date()
            // 通过时间戳计算
            let startTime = date.getFullYear()+'-1-1'// 转化为时间戳
            let defalutStartTime =  moment(startTime).unix() * 1000
            let defalutEndTime = new Date(new Date().setHours(0,0,0,0))

            return {
                xd: {
                    1: '小学',
                    2: '初中',
                    3: '高中',
                    4: '中职',
                },
                coin_sum:0,
                subjects: [],
                activeTab: 'downLog',
                types: {
                    0: "普通",
                    1: "精品",
                    3: "特供",
                },
                searcherModel: {
                    group_id: '',
                    user_name: '',
                    real_name: '',
                    uid: '',
                    stage: '',
                    subject_id: '',
                    asset_type: '',
                    time: [
                        defalutStartTime,
                        defalutEndTime
                    ],
                    customer_id:'',
                    customer_name:'',
                    source: '',
                },
                list: [],
                loading: true,
                // 分页信息
                linkPage: null
            };
        },

        created: function () {
            this.searcherModel.group_id = (this.ztcId)?this.ztcId:'';
            let params = {
                group_id: this.searcherModel.group_id,
                user_name: this.searcherModel.user_name,
                real_name: this.searcherModel.real_name,
                uid: this.searcherModel.uid,
                stage: this.searcherModel.stage,
                subject_id: this.searcherModel.subject_id,
                asset_type: this.searcherModel.asset_type,
                time: this.searcherModel.time,
                source: this.searcherModel.source,
            }

            this.initData(params);
            this.subjects = Params.getSubjects();

        },
        methods: {
            handleView(row){
                let routeData = this.$router.resolve({
                    path: "/customers/view",
                    query: { id: row.customer_id,tab:'product' },
                });
                window.open(routeData.href, '_blank');
            },
            watchPageChange(pageParams) {
                this.loading = true;
                let params = this.searcherModel;
                params['page'] = pageParams["page"];
                params['perPage'] = pageParams["perPage"];
                if(this.searcherModel.time.length>0){
                    params['start_at'] = this.searcherModel.time[0]/1000;
                    params['end_at'] = this.searcherModel.time[1]/1000+86399;
                }
                this.initData(params);
            },
            initData(params = {}) {
                Log.index(params).then(res => {
                    if (res.code == 0) {
                        this.list = res.data;
                        this.coin_sum = 0;
                        if(this.list && this.list.length>0){
                            this.coin_sum = _.reduce(this.list,(memo,item)=>{
                                return   memo + (Number(item.asset_coin) || 0)
                            },0);
                        }
                    }
                    this.loading = false;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                }).catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
            },
            // 筛选查询
            submitSearch() {
                // loading 动画
                this.loading = true;
                let params = {
                    group_id: this.searcherModel.group_id,
                    user_name: this.searcherModel.user_name,
                    real_name: this.searcherModel.real_name,
                    uid: this.searcherModel.uid,
                    stage: this.searcherModel.stage,
                    subject_id: this.searcherModel.subject_id,
                    asset_type: this.searcherModel.asset_type,
                    customer_id: this.searcherModel.customer_id,
                    customer_name: this.searcherModel.customer_name,
                    source: this.searcherModel.source,
                }

                if(this.searcherModel.time && this.searcherModel.time.length>0){
                    params['start_at'] = this.searcherModel.time[0]/1000;
                    params['end_at'] = this.searcherModel.time[1]/1000+86399;
                }

                this.initData(params);
            },
            exportXwt(type){
                let params = [];
                let obj = {
                    group_id: (this.group_id)?this.group_id:this.searcherModel.group_id,
                    user_name: this.searcherModel.user_name,
                    real_name: this.searcherModel.real_name,
                    uid: this.searcherModel.uid,
                    stage: this.searcherModel.stage,
                    subject_id: this.searcherModel.subject_id,
                    asset_type: this.searcherModel.asset_type,
                    time: this.searcherModel.time,
                    customer_id:this.searcherModel.customer_id,
                    customer_name:this.searcherModel.customer_name,
                    source: this.searcherModel.source,
                }
                Object.keys(obj).forEach((key) => {
                    if (key === 'time') {
                        return;
                    }
                    let value = obj[key];
                    if(!value){
                        return;
                    }
                    params.push([key, encodeURIComponent(value)].join('='))
                })
                if(params.length==0 && this.searcherModel.time.length==0){
                    this.$message({
                        message: "请先选择过滤条件,再进行导出",
                        type: "error"
                    });
                    return false;
                }
                let str = params.join('&');
                if(obj.time != null){
                    if (this.searcherModel.time.length > 1) {
                        str += '&start_at=' + this.searcherModel.time[0]/1000 + '&end_at=' + _.sum([this.searcherModel.time[1]/1000,86399])
                    }
                }
                if(type=='log'){
                    let log_params = {
                        group_id: (this.group_id)?this.group_id:this.searcherModel.group_id,
                        user_name: this.searcherModel.user_name,
                        real_name: this.searcherModel.real_name,
                        uid: this.searcherModel.uid,
                        stage: this.searcherModel.stage,
                        subject_id: this.searcherModel.subject_id,
                        asset_type: this.searcherModel.asset_type,
                        customer_id:this.searcherModel.customer_id,
                        customer_name:this.searcherModel.customer_name,
                        source: this.searcherModel.source,
                    }
                    if(obj.time != null) {
                        if (this.searcherModel.time.length > 1) {
                            log_params['start_at'] = this.searcherModel.time[0] / 1000;
                            log_params['end_at'] = this.searcherModel.time[1] / 1000 + 86399;
                        }
                    }
                    let url = 'https://scrm.21cnjy.net/product/recorder-ztcdown/export';
                    Function.exportFile(url, log_params);
                    return false;
                }else if(type=='doc'){
                    window.open('https://scrm.21cnjy.net/product/doc?' + str);
                }

            },
            // 重置筛选表单
            resetForm() {
                this.searcherModel = Object.assign(this.searcherModel, {
                    user_name: '',
                    real_name: '',
                    uid: '',
                    stage: '',
                    subject_id: '',
                    asset_type: '',
                    time: [],
                    customer_name:'',
                    customer_id:'',
                    source: '',
                });
                if(!this.isDialog) this.searcherModel.group_id='';
                this.$refs['customer'].reset();
                this.initData(this.searcherModel);
            },
            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                this.searcherModel.customer_name = object.value;
            },
            showDetail(item) {
                let url;
                if (item.downMode == 4) {
                    // 跳转到工作室视频详情页
                    url = 'https://book.21cnjy.com/studio/video-detail?id=' + item.asset_id;
                } else {
                    // 跳转到资源详情页
                    url = 'https://www.21cnjy.com/H/' + item.stage + '/' + item.subject_id + '/' + item.asset_id + '.shtml';
                }
                window.open(url, "newWindow", "menubar=0,scrollbars=1,height=600, width=1300， resizable=1,status=1,titlebar=0,toolbar=0,location=1");
            }

        }
    };
</script>



// WEBPACK FOOTER //
// src/views/log/xwt.vue